
<div class="browser-warning-panel">
  <div class="browser-warning-panel-component">
    <div class="component-background" @click="close" />
    <div class="wrapper" @click="openChrome">
      <!-- <button class="delete is-medium close" @click="close" /> -->
      <div class="columns is-mobile">
        <p class="column is-narrow">
          <img src="/img/home2/chrome.svg" @click="openChrome" />
        </p>
        <p class="column warning">
          {{ $t("bad-browser") }}
          <i class="fa fa-chevron-right" style="margin-left: 4px" />
        </p>
      </div>
    </div>
  </div>
</div>
